<q-bodisplay [param]="param" (sendEvent)="getIdBoRdv($event)"></q-bodisplay>
